import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const AuthContext = createContext({ user: null, token: null, login: () => {}, logout: () => {}, setSession: () => {} });

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("motravay_token"));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  // When setSession is called with a fresh user, skip the next /auth/me refetch
  const sessionPrimed = useRef(false);

  useEffect(() => {
    if (!token) { setUser(null); setLoading(false); return; }
    if (sessionPrimed.current) {
      sessionPrimed.current = false;
      setLoading(false);
      return;
    }
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setUser(r.data))
      .catch(() => { localStorage.removeItem("motravay_token"); setToken(null); })
      .finally(() => setLoading(false));
  }, [token]);

  const setSession = (newToken, newUser) => {
    if (newToken) {
      localStorage.setItem("motravay_token", newToken);
      if (newUser) {
        sessionPrimed.current = true;
        setUser(newUser);
      }
      setToken(newToken);
    } else if (newUser) {
      setUser(newUser);
    }
  };

  const logout = () => {
    localStorage.removeItem("motravay_token");
    setToken(null);
    setUser(null);
  };

  const authHeader = token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <AuthContext.Provider value={{ user, token, loading, setSession, logout, authHeader }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
